import { rollbar } from '@centerpiece/components';
import fileDownload from 'js-file-download';
import { toast } from 'react-toastify';

export const downloadFile = async ({
  url,
  name,
}: {
  url: string;
  name: string;
}) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
    });
    //@ts-ignore
    const myBlob = await response.blob();
    await fileDownload(myBlob, name);
  } catch (error: any) {
    toast.error(`Unable to download file: ${name}`);
    rollbar.error(`Unable to download file: ${name}`);
  }
};
